module.exports = __webpack_public_path__ + "media/assets/images/face-upload/browse-e656010ac9d951bbd31f91dd88f86aa9.png";